import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // send httpOnly session cookie
});

// Read the CSRF cookie (double-submit pattern).
function getCookie(name) {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

api.interceptors.request.use((cfg) => {
  // Attach CSRF header for state-changing requests.
  const method = (cfg.method || "get").toLowerCase();
  if (["post", "patch", "put", "delete"].includes(method)) {
    const csrf = getCookie("figuraid_csrf");
    if (csrf) cfg.headers["X-CSRF-Token"] = csrf;
  }
  // Legacy Bearer fallback (kept so /api CLI clients still work).
  const token = localStorage.getItem("figuraid_token");
  if (token && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("figuraid_token");
      localStorage.removeItem("figuraid_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const formatNaira = (n) => {
  const num = Number(n || 0);
  return `₦${num.toLocaleString("en-NG", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-NG", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-NG", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const formatApiError = (detail) => {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
};
